"use client";

import { isDeepEqual } from "@noya-app/noya-utils";
import { useMemo, useState } from "react";

/**
 * Memoize an array using deep equality comparison (by converting to JSON).
 */
export function useDeepMemo<T>(value: T) {
  const [_value, setValue] = useState(value);

  if (!isDeepEqual(_value, value)) {
    setValue(value);
  }

  return _value;
}

export function useJsonMemo<T>(value: T): T {
  const stringified = useMemo(
    () => (value === undefined ? undefined : JSON.stringify(value)),
    [value]
  );
  const parsed = useMemo(
    () => (stringified === undefined ? undefined : JSON.parse(stringified)),
    [stringified]
  );
  return parsed;
}
